import { associateScorecardService } from 'config/api';
import actionTypes from './actionTypes';

export const getExpandedScorecard = (associatePin, filterType = 'QUARTER_TO_DATE', category) => async (dispatch) => {
  dispatch({ type: actionTypes.ASSOCIATE_EXP_SCORECARD_LOADING });

  const postBody = { filterType };

  try {
    const { data } = await associateScorecardService.post(`/v1/finalscorecard/${associatePin}/details`, postBody);
    dispatch({
      type: actionTypes.ASSOCIATE_EXP_SCORECARD_SUCCESS,
      payload: { data, category },
    });
  } catch (error) {
    dispatch({ type: actionTypes.ASSOCIATE_EXP_SCORECARD_ERROR });
  }
};

export const clearExpandedScorecard = () => ({
  type: actionTypes.ASSOCIATE_EXP_SCORECARD_CLEAR,
});
